import { AfterViewChecked, Component, OnInit } from '@angular/core';
import * as memAnalysisSelector from '@app/selectors/myoffice/member/member-analysis.selector';
import { chartMemberAge, chartMemberGender, chartMemberMonth, chartMemberRank } from '@app/actions/myoffice/member/affiliate-member-analysis.action';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AnalysisMember } from '@models/myoffice/member/analysis-member.model'
import { AnalysisMemberMonth } from '@models/myoffice/member/analysis-member-month.model'
import { AnalysisAge } from '@models/myoffice/member/analysis-age.model'
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { ChartUtils } from '@app/common/util/chart.ultil';
import { ChartType } from "angular-google-charts";
import { AuthUtil } from '@app/common/util/auth.util';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { Router } from '@angular/router';
import { OrderAnalysicModel } from '@app/models/myoffice/order/order-analysic.model';
import { OrderAnalysisState, getOrderAnalysisByAge, getOrderAnalysisByCate, getOrderAnalysisByMonth, getOrderAnalysisByProduct, getOrderAnalysisByRank } from '@app/selectors/myoffice/order/order-analysis.selector';
import { orderAnalysicByAge, orderAnalysicByCate, orderAnalysicByMonth, orderAnalysicByProduct, orderAnalysicByRank } from '@app/actions/myoffice/order/order-analysis.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { setWAlert } from '@app/actions/w-alert.action';
@Component({
  selector: 'app-order-analysis',
  templateUrl: './order-analysis.component.html',
  styleUrls: ['./order-analysis.component.css']
})
export class OrderAnalysisComponent implements OnInit {

  type = ChartType.PieChart;
  maxValueChart : number = 0;


  userId: string = ''
  year:string = '';



  // order-analysis-rank
  dataOrderChartRank: any[] = [];
  optionOrderChartRank = {
    legend: { position: 'top', alignment: 'center', maxLines: 15 },
    // height: '100%',
    // width: '100%'
    height: 300,
    width: 300
  };
  orderAnalysisRank$ = new Observable<OrderAnalysicModel[]>;
  orderAnalysisRank =[] as OrderAnalysicModel[];

  // order-analysis-age
  dataOrderChartAge: any[] = [];
  optionOrderChartAge = {
    legend: { position: 'top', alignment: 'center', maxLines: 15},
    // height: '100%',
    // width: '100%'
    height: 300,
    width: 300
  };
  orderAnalysisAge$ = new Observable<OrderAnalysicModel[]>;
  orderAnalysisAge =[] as OrderAnalysicModel[];

  // order - analysis-month
  orderAnalysisMonth$ = new Observable<OrderAnalysicModel>;
  orderAnalysisMonth = {} as OrderAnalysicModel;
  totalMonthAmt :number = 0;

  // order-analysis-cate
  dataOrderChartCate: any[] = [];
  optionOrderChartCate = {
    legend: { position: 'top', alignment: 'center', maxLines: 15},
    // height: '100%',
    // width: '100%'
    height: 300,
    width: 300
  };
  orderAnalysisCate$ = new Observable<OrderAnalysicModel[]>;
  orderAnalysisCate =[] as OrderAnalysicModel[];


  // order - analysis-month
  orderAnalysisProduct$ = new Observable<OrderAnalysicModel[]>;
  orderAnalysisProduct = [] as OrderAnalysicModel [];
  totalProductAmt :number = 0;




  typeSearch:string ="group";
  public href: string = "";

  constructor(
    
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _orderAnalysisStore: Store<OrderAnalysisState>,
    private router : Router,
    private _wAlertStore: Store<WAlertState>,
  ) {
 

    this.orderAnalysisRank$ =  this._orderAnalysisStore.select(getOrderAnalysisByRank);
    this.orderAnalysisAge$ =  this._orderAnalysisStore.select(getOrderAnalysisByAge);
    this.orderAnalysisMonth$ =  this._orderAnalysisStore.select(getOrderAnalysisByMonth);
    this.orderAnalysisCate$ = this._orderAnalysisStore.select(getOrderAnalysisByCate);
    this.orderAnalysisProduct$ = this._orderAnalysisStore.select(getOrderAnalysisByProduct)
  }
  ngAfterViewChecked(): void {
    ChartUtils.drawChartBar("chart-member-rank")
  }

  ngOnInit(): void {
    this.href = this.router.url;

    if(this.href.includes("center")){
      this.typeSearch = "center"
    }else if(this.href.includes("group")){
      this.typeSearch = "group"
    }
    let member = AuthUtil.getLoginedInfo();
    if (member) {
      this.userId = ConvertUtil.convertToSring(member.userid);
    }

    let now = new Date();
    this.year = ConvertUtil.convertToSring(now.getFullYear());

    this.orderAnalysisRank$.subscribe(res =>{
      this.dataOrderChartRank = []
      let amt = 0;
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        for (var i = 0; i < res.length; i++) {
          this.dataOrderChartRank.push([res[i].rankName, Number(res[i].amt)]);
          amt = amt + Number(res[i].amt)
        }
      }
      if(amt == 0){
        this.dataOrderChartRank = [['조회된 데이타가 없습니다.', 10]];
      }
    })

    this.orderAnalysisAge$.subscribe(res =>{
      this.dataOrderChartAge = []
      let amt = 0;
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        for (var i = 0; i < res.length; i++) {
          this.dataOrderChartAge.push([res[i].age + '대', Number(res[i].amt)]);
          amt = amt + Number(res[i].amt)
        }
      }
      if(amt == 0){
        this.dataOrderChartAge = [['조회된 데이타가 없습니다.', 10]];
      }
    })

    this.orderAnalysisCate$.subscribe(res =>{
      let amt = 0;
      this.dataOrderChartCate = []
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        for (var i = 0; i < res.length; i++) {
          this.dataOrderChartCate.push([res[i].cateName, Number(res[i].amt)]);
          amt = amt + Number(res[i].amt)
        }
      } 
      if(amt == 0){
        this.dataOrderChartCate = [['조회된 데이타가 없습니다.', 10]];
      }
    })

    this.orderAnalysisMonth$.subscribe(res => {
      if(res){
        this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
        if(ValidationUtil.isNotNullAndNotEmpty(res)){
          this.totalMonthAmt =Number(res.total);
          this.orderAnalysisMonth = res;
        }
        
      }
    });

    this.orderAnalysisProduct$.subscribe(res => {
      if(res){
        this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
        for (var i = 0; i < res.length; i++) {
          let item = res[i];
          if(ValidationUtil.isNotNullAndNotEmpty(item.amt)) {
            let totalAmtNumber =0;
            for(i == 0 ; i<res.length ; i++){
              totalAmtNumber +=  Number(res[i].amt) 
            }

            this.totalProductAmt = totalAmtNumber;

          }
        }
      }
    });
    this.onSearch()
  }
  onSearch(){
   
    setTimeout(() => {
      this._overlayLoadingStore.dispatch( setShowOverlayLoading({loading: true }));
    }, 1);
   

    // order-analysis-rank
    this._orderAnalysisStore.dispatch(orderAnalysicByRank({year:this.year ,userid:this.userId, typesearch:this.typeSearch}))
    // order-analysis-age
    this._orderAnalysisStore.dispatch(orderAnalysicByAge({year:this.year ,userid:this.userId, typesearch:this.typeSearch}))
     // order-analysis-month
     this._orderAnalysisStore.dispatch(orderAnalysicByMonth({year:this.year ,userid:this.userId, typesearch:this.typeSearch}))
     // order-analysis-cate
     this._orderAnalysisStore.dispatch(orderAnalysicByCate({year:this.year ,userid:this.userId, typesearch:this.typeSearch}))
      // order-analysis-product
      this._orderAnalysisStore.dispatch(orderAnalysicByProduct({year:this.year ,userid:this.userId, typesearch:this.typeSearch}))

    
  }

  
  getHeigthOfElement(totalAmt : String) : number {
       if(this.totalMonthAmt == 0){
        return 0;
       }
    if(ValidationUtil.isNotNullAndNotEmpty(totalAmt)) {
      let totalAmtNumber = Number(totalAmt);
      let _height = 0;
          _height = totalAmtNumber / this.totalMonthAmt * 200;
      return _height;
    }


    return 0;
  }
  
  getHeigthOfElementProduct(totalAmt : String) : number {
    if(this.totalProductAmt == 0){
     return 0;
    }
    if(ValidationUtil.isNotNullAndNotEmpty(totalAmt)) {
      let totalAmtNumber = Number(totalAmt);
      let _height = 0;
          _height = totalAmtNumber / this.totalProductAmt * 200;
      return _height;
    }


    return 0;
  }

  handleOnClickCalendarButton(kind:string){
    let number = Number(this.year);
    if(kind === '+'){
      let now = new Date();
      if( Number(this.year) >= Number(ConvertUtil.convertToSring(now.getFullYear()))){
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: MessageConstant.msgWarningCalendar} }));
       this.year = ConvertUtil.convertToSring(now.getFullYear());
      }else{
        number = number+1
        this.year = ConvertUtil.convertToSring(number);
        this.onSearch();
      }
    }else{
      number = number- 1
      this.year = ConvertUtil.convertToSring(number);
      this.onSearch();
    }
  }

  getNumber(number:any):number{
    return Number(number);
  }

}
